import useContract from "@hooks/useContract";

const useVaporControllerContract = () => {
	const { vaporControllerContract } = useContract();

	return vaporControllerContract;
};

export default useVaporControllerContract;
